export const SURVEY_STATUS = {
  draft: 'draft',
  active: 'active',
  inactive: 'inactive',
  archived: 'archived',
};
